








































































import {
  CentralNotificacoesService,
  Notificacao,
  TipoNotificacao,
} from "@/services/central-notificacao.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import { required } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";
import ComboTipoNotificacao from "./ComboTipoNotificacao.vue";

@Component({
  components: {
    WysiwygEditor,
    ComboTipoNotificacao,
    Loading,
    Modal,
  },
})
export default class Manter extends Vue {
  notificacao: Notificacao | null = null;
  valid = false;
  loading = false;
  erroDescricao = false;
  arquivo: File | null = null;
  snackbar = false;
  snackbarMessage = "";
  excluirImagem = false;

  rules = {
    titulo: [required()],
    idTipoNotificacao: [required()],
    descricao: [required()],
  };

  rulesFileInput = [
    (value: File | null) => {
      if (!value) {
        return true;
      }

      return value.size <= 40 * 1024 || "O arquivo deve ter no máximo 40KB";
    },
  ];

  get tituloManter(): string {
    return this.notificacao?.idNotificacao == null
      ? "Nova Notificação"
      : "Alterar Notificação";
  }

  removerImagemAtual() {
    this.excluirImagem = true;
    this.notificacao!.imagem = null;
    this.notificacao!.imagemCompleta = null;
  }

  async salvarNotificacao() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    this.erroDescricao = false;

    if (!form.validate() || !this.notificacao) {
      return;
    }

    if (this.arquivo) {
      const valido = await this.validarProporcao(this.arquivo, 360, 270);
      if (!valido) {
        this.mostrarErro("A imagem deve ter proporção de 360x270 (ex: 720x540, 1080x810 etc.)");
        return;
      }
    }

    if (!this.notificacao.descricao) {
      this.erroDescricao = true;
      return;
    }

    this.loading = true;
    await CentralNotificacoesService.manterNotificacao(this.notificacao, this.arquivo, this.excluirImagem);
    this.loading = false;

    modal.close(true);
  }

  private async validarProporcao(file: File, largura: number, altura: number): Promise<boolean> {
    return new Promise((resolve) => {
      const proporcaoEsperada = largura / altura;
      const img = new Image();

      img.onload = () => {
        const proporcaoReal = img.width / img.height;
        const dentroDaTolerancia = Math.abs(proporcaoReal - proporcaoEsperada) <= 0.01;
        resolve(dentroDaTolerancia);
      };

      img.onerror = () => resolve(false);

      img.src = URL.createObjectURL(file);
    });
  }

  mostrarErro(msg: string) {
    this.snackbarMessage = msg;
    this.snackbar = true;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarNotificacao(id: string) {
    this.excluirImagem = false;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.notificacao = await CentralNotificacoesService.obterNotificacao(id);
    this.arquivo = null;
    this.loading = false;

    return p;
  }

  public async novaNotificacao() {
    this.excluirImagem = false;
    const modal = this.$refs.modal as Modal;

    this.notificacao = {
      tipoNotificacao: {} as TipoNotificacao,
    } as Notificacao;

    this.arquivo = null;

    return modal.open();
  }
}
